module.exports = "<div class=\"animate-show\" *ngIf=\"isPremier\">\n\t<ng-content></ng-content>\n</div>"